import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  const handleHardRefresh = () => {
    // Clear session cache and force reload to get latest deployment assets
    if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4">
      <div className="max-w-md w-full rounded-2.5xl bg-white dark:bg-boxdark border border-brand-line dark:border-strokedark p-8 shadow-card text-center">
        {/* 404 Visual Icon */}
        <div className="w-16 h-16 rounded-2xl bg-brand-blue-tint dark:bg-brand-900/40 text-brand-vib dark:text-brand-300 flex items-center justify-center mx-auto mb-4 border border-brand-vib/20">
          <span className="text-2xl font-mono font-bold">404</span>
        </div>

        <h1 className="text-xl font-bold text-brand-navy dark:text-white tracking-tight mb-2">
          Page Not Found
        </h1>

        <p className="text-xs sm:text-sm text-brand-muted dark:text-bodydark mb-6 leading-relaxed">
          The requested page or invoice could not be found. This may happen if the invoice was archived or if a new version was recently deployed.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto px-5 py-2.5 rounded-xl text-xs font-semibold bg-brand-vib text-white hover:bg-brand-vib-hover transition-colors shadow-sm text-center"
          >
            Go to Dashboard
          </Link>
          <Link
            to="/invoices"
            className="w-full sm:w-auto px-5 py-2.5 rounded-xl text-xs font-semibold text-brand-navy dark:text-white border border-brand-line dark:border-strokedark hover:bg-brand-bg dark:hover:bg-strokedark transition-colors text-center"
          >
            View Invoice List
          </Link>
        </div>

        <div className="pt-6 mt-6 border-t border-brand-line/60 dark:border-strokedark">
          <button
            type="button"
            onClick={handleHardRefresh}
            className="text-xs font-mono text-brand-soft hover:text-brand-vib dark:hover:text-brand-light transition-colors cursor-pointer"
          >
            ↻ Check for updated application version
          </button>
        </div>
      </div>
    </div>
  );
}
